import { useState } from 'react';
import { financeOptionsItems } from 'utils/finance-options'
import finOptionActive from "assets/images/icons/fin-option-active.svg";
import finOptionInactive from "assets/images/icons/fin-option-inactive.svg";


const FinancingOptions = () => {
    const [activeItem, setActiveItem] = useState(financeOptionsItems[0]);
    const formUrl = "https://docs.google.com/forms/d/e/1FAIpQLScgwlSGL7_Hrzi0AmEjJ4wWRqvXNy-UXjCV1cpTXkDpd9AxcQ/viewform"
    const singleInterestFee = activeItem?.interestFeeItems?.length === 1

    return (
        <div>
            <p className="mb-1 text-ep-primary-700">
                Earnipay reduces how long your business and employees wait to get paid with tailored financing options to provide liquidity and unlock business cashflow
            </p>
            <div className="mt-14 lg:mt-20 flex items-start justify-center lg:flex-row lg:justify-between flex-wrap lg:flex-nowrap">
                <div className="w-full border finance-option-wrap rounded-lg flex flex-col">
                    {financeOptionsItems.map((item, index) => {
                        const isActive = item.parentHeader === activeItem.parentHeader
                        return  <div key={index} style={{backgroundColor: isActive ? "rgba(184, 201, 208, 0.2)" : ""}} onClick={() => setActiveItem(item)}
                                    className={`w-full py-6 px-5 transition-colors cursor-pointer flex items-start justify-between ${isActive && "rounded-md font-medium"}`}>
                                    <div className="w-4/5">
                                        <p className={`capitalize mb-5 ${isActive ? "font-medium text-ep-primary-600" : "text-[#718096]"}`}>{item.parentHeader}</p>
                                        {isActive && <p className="text-[14px] ws-3/5 text-[#374151]">{item.parentSubheader}</p>}
                                    </div>

                                    <div className="w-1/5 flex justify-end">
                                        <img src={isActive ? finOptionActive : finOptionInactive} alt="" />
                                    </div>
                                </div>
                    })}
                </div>
                <div className="w-full p-5 border border-[#B8C9D0] bg-[#EDFAF6] finance-option-wrap mt-16 lg:mt-0 rounded-lg">
                    <p className="lg:text-xl text-ep-primary-700 font-semibold capitalize">{activeItem.parentHeader}</p>
                    <div className="border my-4 w-2/5" />

                    <div className='mb-5'>
                        <p className="fin-option-header">What is it?</p>
                        <p>{activeItem.itemDefinition}</p>
                        {activeItem?.itemDefinition2 && <p className="my-6">{activeItem.itemDefinition2}</p>}
                    </div>

                    {activeItem.applicationSteps && <div className='mb-5'>
                        <p className="fin-option-header">Mode of Application</p>
                        {activeItem.applicationSteps.map((item,index) => (
                        <p className='mb-1'>{index + 1}.&nbsp;{item}</p>
                        ))}
                    </div>}

                    {activeItem.limits && <div className='mb-5'>
                        <p className="fin-option-header">Limits</p>
                        <p className='mb-1'>{activeItem.limits}</p>
                    </div>}

                    <div className='mb-5'>
                        <p className="fin-option-header">How much is the interest fee, and how is it calculated?</p>
                        {activeItem.interestFeeItems.map((item,index) => singleInterestFee ? (
                        <p className='mb-1'>&#8226;&nbsp;{item}</p>
                            ) : ( <p className='mb-1'>{index + 1}.&nbsp;{item}</p>
                        ))}
                    </div>

                    <div className='mb-5'>
                        <p className="fin-option-header">Requirements</p>
                        {activeItem.requirements.map((item,index) => (
                        <p className='mb-1'>{index + 1}.&nbsp;{item}</p>
                        ))}
                    </div>

                    <div className='mb-8'>
                        <p className="fin-option-header">Turn Around Time</p>
                        <p className='mb-1'>{activeItem.turnAroundTime}</p>
                    </div>
                    <button onClick={() => window.open(formUrl, "_blank", "noreferrer")} className="btn btn-md btn-ep-primary">Apply for Financing</button>
                </div>
            </div>
        </div>
    )
}

export default FinancingOptions